import { ProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"

export const getRecommendedMedications = (data: ProgressNoteData) => {
  return (
    (data.__typename === "ch_ProgressNote"
      ? data.ch_recommendedMedications?.edges
      : data.de_recommendedMedications?.edges) ?? []
  )
}

export const isRecommendedMedicationsEmpty = (data: ProgressNoteData) =>
  (getRecommendedMedications(data) ?? []).length === 0
